module.exports = __webpack_public_path__ + "img/logo-limpio.1f7791c5.png";